"use client";

import styled from "styled-components";

interface BackgroundProps {
  $width: string;
  $height: string;
  $borderRadius: string;
}

export const Background = styled.div<BackgroundProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${({ $width }) => $width};
  height: ${({ $height }) => $height};
  padding: 0.1rem;
  flex-shrink: 0;
  border-radius: ${({ $borderRadius }) => $borderRadius};
  background-color: #fff;
  border: 1px solid #e5e7eb;

  img {
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }

  .article-detail-mobile-ui-true &.article-detail-company-image {
    width: 2.4rem;
    height: 2.4rem;
  }
  .article-detail-mobile-ui-true &.investor-logo {
    width: 2.8rem;
    height: 2.8rem;
  }

  @media only screen and (max-width: 768px) {
    &.article-detail-company-image {
      width: 2.4rem;
      height: 2.4rem;
    }
    &.investor-logo {
      width: 2.8rem;
      height: 2.8rem;
    }
  }
`;
